document.querySelectorAll('[data-manual-search]').forEach((form) => {
  if (form.dataset.manualSearchReady === 'true') return;

  const section = form.closest('.yoria-blog__manuals');
  if (!section) return;

  const input = form.querySelector('[data-manual-search-input]');
  const cards = [...section.querySelectorAll('[data-manual-card]')];
  const empty = section.querySelector('[data-manual-search-empty]');
  const status = section.querySelector('[data-manual-search-status]');

  if (!input) return;

  if (!empty || !status || cards.length === 0) {
    form.addEventListener('submit', (event) => event.preventDefault());
    form.dataset.manualSearchReady = 'true';
    return;
  }

  const normalize = (value) => value.normalize('NFKC').trim().toLocaleLowerCase();
  const filter = () => {
    const query = normalize(input.value);
    let visible = 0;

    cards.forEach((card) => {
      const matches = !query || normalize(card.dataset.manualSearchText).includes(query);
      card.hidden = !matches;
      if (matches) visible += 1;
    });

    empty.hidden = visible > 0;
    status.textContent = query
      ? `${visible}${form.dataset.resultsLabel}${cards.length}${form.dataset.resultsSuffix}`
      : '';
  };

  const initialQuery = new URL(window.location.href).searchParams.get('manual_q');
  if (initialQuery) input.value = initialQuery;
  filter();

  input.addEventListener('input', filter);
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    filter();
    const url = new URL(window.location.href);
    input.value.trim() ? url.searchParams.set('manual_q', input.value.trim()) : url.searchParams.delete('manual_q');
    window.history.replaceState({}, '', url);
  });

  form.dataset.manualSearchReady = 'true';
});
